import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const regenerateBarcodes = (payload: any) => {
    return ApiService[APIConfig.REGENERATE_BARCODES.METHOD](APIConfig.REGENERATE_BARCODES.URL, payload);
}

const downloadBarcodes = (testId:any,payload: any)=>{
    return ApiService[APIConfig.DOWNLOAD_BARCODES.METHOD](APIConfig.DOWNLOAD_BARCODES.URL(testId), payload);
}

const uploadBulkBarcodes = (payload:any) =>{
    return ApiService[APIConfig.BULK_ADD_BARCODES.METHOD](APIConfig.BULK_ADD_BARCODES.URL, payload);
}

const BarcodeService = {
    regenerateBarcodes,
    downloadBarcodes,
    uploadBulkBarcodes
}
export default BarcodeService;